import styled from 'styled-components'

export const AppBarWrapper = styled.div`
  border-radius: 5px;
  z-index: 1;
  position: relative;
  align-items: center;
  width: 227px;
`

export const AppBarIcon = styled.img`
  width: 127px;
  height: 127px;
  justify-content: center;
  align-items: center;
  display: block;
  margin: 0 auto;
  margin-top: 10px;
`
